import { windowIsDefined } from '@klv/shared/utils/functions';
import { hasStorageAvailable } from '@klv/shared/utils/storage';

import type { Dispatch, SetStateAction } from 'react';


const ALERT_BAR_STORAGE_KEY = 'alertBarDismissed';

export const handleDismiss = (setter: Dispatch<SetStateAction<boolean>>) => {
  if (hasStorageAvailable('sessionStorage')) {
    sessionStorage.setItem(ALERT_BAR_STORAGE_KEY, 'true');
  }
  setter(true);
};

export const getDismissed = () => (
  windowIsDefined()
  && hasStorageAvailable('sessionStorage')
  && sessionStorage.getItem(ALERT_BAR_STORAGE_KEY) === 'true'
);

export const stripTags = (message: string) => (
  message
    .replaceAll('<p>', '')
    .replaceAll('</p>', '')
    .trim()
);
